export interface MembershipPermissions {
  role: string | null;
  canManageMembers: boolean;
  canManageApiKeys: boolean;
  canManageBilling: boolean;
}

export function parseMembershipPermissions(data: any = {}): MembershipPermissions {
  return {
    role: data.role ?? null,
    canManageMembers: !!data.can_manage_members,
    canManageApiKeys: !!data.can_manage_api_keys,
    canManageBilling: !!data.can_manage_billing,
  };
}
